import React from 'react'
import { content } from '../index'
import { Project } from 'src/core/models'
import { projectIsOutOfStock } from 'src/core/helpers'
import styles from './ProjectDetailMainCard.module.scss'

interface ProjectDetailMainCardProps {
  project: Project
  isModalPreview: boolean
  saleOfferContent: React.ReactNode
}

const ProjectDetailMainCard: React.FC<ProjectDetailMainCardProps> = (props) => {
  const { project, isModalPreview, saleOfferContent } = props
  const isOutOfStock = projectIsOutOfStock(project)
  const backGround = { backgroundImage: `url(${project?.cover})` }

  return (
    <>
      <div className={styles.card} style={backGround}>
        {/* Card Badges */}
        <content.ProjectCardBadges
          project={project}
          isOutOfStock={isOutOfStock}
          saleOfferContent={saleOfferContent}
        />

        <div className={styles.content}>
          <div className={styles.nameContent}>
            <div className={styles.nameWidth}>
              <content.ProjectKindContent project={project} />
            </div>
          </div>
        </div>

        {/* Gray Color Effect if Project is Out Of Stock */}
        {isOutOfStock && <div
          className={styles.mask}
          style={backGround}
        />}
      </div>

      {saleOfferContent ? saleOfferContent : (
        <content.ProjectPriceDetailCard
          project={project}
          isModalPreview={isModalPreview}
        />
      )}
    </>
  )
}

export default ProjectDetailMainCard
